import React, { Component } from 'react';
import { connect } from "react-redux";

//component
import QRReader from "../../../../qrreader/helper/component/QRReader.js";

class QRReaderScreen extends Component {
	render(){
		return (
			<div className="animated fadeIn">
			  	<div className="row">
					<div className="col-md-12">
						<div className="card">
							<QRReader {...this.props} />
				 		</div>
					</div>
			  	</div>
			</div>
		);
		
	}
}

const mapStateToProps = state => {
	return {
		UserReducer: state.UserReducer,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		RunRedux: data => {
			dispatch(data);
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(QRReaderScreen);


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/qrReader/QRReader.js